import axios from "axios";

class Auth {
  login(username, password, cb) {
    if (sessionStorage.token) {
      if (cb) cb(true);
      return;
    }

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/login`, { username, password })
      .then(result => {
        if (result.data.token) {
          sessionStorage.setItem("token", result.data.token);
          sessionStorage.setItem("plan", result.data.plan);
          cb(true);
        } else {
          cb(false);
        }
      })
      .catch(err => cb(false));
  }

  getToken() {
    return sessionStorage.token;
  }

  getPlan() {
    return sessionStorage.plan;
  }

  logout(cb) {
    delete sessionStorage.token;
    if (cb) cb();
  }

  isLoggedIn() {
    return !!sessionStorage.token;
  }
}

export default new Auth();



// WEBPACK FOOTER //
// ./src/Auth.js